
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref718"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref718"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $e84c40600c213673$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["jAqLr","index.e67f7c11.js","f8o1H","Logo.2040407e.png","dSOjy","eyelid.03d065bc.svg","8OXic","shuteyelid.974676f6.svg","6Y12V","check.596ad38e.svg","hOSW8","ThumbsUp.cfdac9dc.svg","b94EG","ThumbsDown.5a2a8553.svg","fS27i","NewWorldMap.6ca8ffea.svg","jcIjZ","helloUser.a8b91bae.svg","gMF0z","SquarePlaceholder100.55375be1.svg","gIYuN","statementLogo.a2414c6d.png","f2zam","index.928de642.css"]'));


//# sourceMappingURL=index.runtime.a3c1ca60.js.map
